module.exports = __webpack_public_path__ + "img/weishi_code.309a5ff7.png";